import React from "react";

import { Pagination } from "react-admin";

const LargePagination = (props) => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200, 500]} {...props} />;

export default LargePagination;
